const MobileDetails = ({ onEnquire }) => {
  return (
    <div className="px-5 py-6 text-center">
      <span className="inline-block bg-blue-800 text-white text-sm px-3 py-1 rounded-full">
        Bookings Open
      </span>

      <h2 className="text-2xl font-bold mt-3">Rainbow Life Kharghar</h2>
      <p className="text-lg text-gray-800">By Siddhi Group</p>

      <p className="text-sm text-gray-700 mt-1">
        Kharghar sec - 37, Navi Mumbai
      </p>

      <div className="flex flex-wrap justify-center gap-3 mt-5 text-sm text-white font-bold">
        <div className="bg-[#6B7280] py-2 px-4 rounded-lg">
          Possession : 2028
        </div>
        <div className="bg-[#6B7280] py-2 px-4 rounded-lg">Land Parcel : 4.5 Acres</div>
        <div className="bg-[#6B7280] py-2 px-4 rounded-lg">
          Floors : G+36 Floors
        </div>
      </div>

      <div className="mt-5">
        <p className="text-sm">Exlusive Spacious 2, 3, 4 & 5 BHK apartments</p>
        <p className="text-2xl font-bold text-[#1E40AF]">₹ 1.23 Cr* Onwards</p>
      </div>

      <button
        className="mt-5 w-1/2 bg-[#090c6a] text-white py-3 rounded-xl font-medium shadow-lg active:scale-95 transition"
        onClick={onEnquire}
      >
        Enquire Now
      </button>
    </div>
  );
};

export default MobileDetails;
